import { render } from "./ljSucc.vue?vue&type=template&id=96061532"
import script from "./ljSucc.vue?vue&type=script&lang=js"
export * from "./ljSucc.vue?vue&type=script&lang=js"

import "./ljSucc.vue?vue&type=style&index=0&id=96061532&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__